import { AreaClosed } from '@visx/shape';

import type { scaleLinear, scaleUtc } from '@visx/scale';
import { curveMonotoneX } from 'd3-shape';

interface Props {
  data: [Date, number][];
  fill?: string;
  fillOpacity?: string | number;
  xScale: ReturnType<typeof scaleUtc<number>>;
  yScale: ReturnType<typeof scaleLinear<number>>;
}

export const AreaPlot = ({
  data,
  xScale,
  yScale,
  fill = 'white',
  fillOpacity = 0.5,
}: Props) => (
  <AreaClosed
    data={data}
    x={([date]) => xScale(date)}
    y={([_, value]) => yScale(value || 0)}
    y0={() => yScale.range()[0]}
    yScale={yScale}
    fill={fill}
    fillOpacity={fillOpacity}
    curve={curveMonotoneX}
  />
);
